"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var input_1 = require("../styled/input");

var label_1 = require("../styled/label");

var radio_1 = require("../styled/radio");

var RadioButton = function RadioButton(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      disabled = _a.disabled,
      id = _a.id,
      label = _a.label,
      subtitle = _a.subtitle,
      value = _a.value;

  var _b = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'RadioButton',
    className: className,
    __UIScope: __UIScope
  }),
      rootClasses = _b.rootClasses,
      makeClasses = _b.makeClasses;

  var fieldsetId = (0, use_id_1.useId)(id);
  var contextValue = (0, react_1.useContext)(context_1.RadioButtonsContext);

  if (!contextValue) {
    return null;
  }

  var name = contextValue.name,
      onChange = contextValue.onChange,
      selectedValue = contextValue.selectedValue,
      isInverse = contextValue.isInverse,
      hasErrors = contextValue.hasErrors;
  return react_1.default.createElement(radio_1.Radio, {
    className: rootClasses,
    "data-testid": testID,
    hasSubtitle: Boolean(subtitle),
    hasErrors: hasErrors,
    isInverse: isInverse
  }, react_1.default.createElement(input_1.Input, {
    className: makeClasses('Input'),
    type: "radio",
    id: fieldsetId,
    name: name,
    value: value,
    checked: value === selectedValue,
    onChange: onChange,
    disabled: disabled
  }), react_1.default.createElement(label_1.Label, {
    className: makeClasses('Label'),
    htmlFor: fieldsetId,
    pattern: "body",
    color: isInverse ? 'grey-white' : 'grey-800'
  }, react_1.default.createElement(label_1.LabelFlex, {
    flexDirection: "column"
  }, children, label, subtitle && react_1.default.createElement(label_1.Subtitle, {
    className: makeClasses('Subtitle'),
    color: isInverse ? 'grey-400' : 'grey-medium',
    pattern: "caption"
  }, subtitle))));
};

RadioButton.displayName = 'RadioButton';
var RadioButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(RadioButton);
exports.RadioButton = RadioButtonWithSpace;